import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

const heroBg =
  'https://readdy.ai/api/search-image?query=Premium%20fashion%20product%20flat%20lay%20on%20warm%20cream%20marble%20surface%20with%20white%20sneakers%20hoodies%20t-shirts%20bags%20and%20accessories%20arranged%20artistically%20soft%20natural%20lighting%20editorial%20photography%20high%20detail%20warm%20neutral%20tones%20no%20text&width=1600&height=900&seq=hero-cssbuy-01&orientation=landscape';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[720px] w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt="AllChinaBuy Spreadsheet product directory"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-28 text-center md:px-6 md:py-32">
        <span className="animate-fade-up inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs font-medium tracking-wide text-white/90 backdrop-blur-sm">
          <i className="ri-sparkling-2-line"></i>
          {t('hero.badge')}
        </span>

        <h1 className="animate-fade-up-delay-1 mt-8 font-heading text-4xl font-bold leading-[1.15] text-white md:text-6xl">
          {t('hero.titlePre')}{' '}
          <span className="text-primary-400">{t('hero.titleHighlight')}</span>
          <br className="hidden md:block" /> {t('hero.titleSuffix')}
        </h1>

        <p className="animate-fade-up-delay-2 mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/80 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="animate-fade-up-delay-3 mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white px-8 py-4 text-sm font-semibold text-foreground-900 transition-colors hover:bg-background-100 sm:w-auto cursor-pointer"
          >
            {t('hero.cta1')}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-8 py-4 text-sm font-semibold text-white transition-colors hover:bg-primary-600 sm:w-auto cursor-pointer"
          >
            {t('hero.cta2')}
          </a>
        </div>

        <div className="animate-fade-up-delay-3 mt-8 flex flex-wrap items-center justify-center gap-6 text-xs text-white/60">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-primary-400"></i>
            {t('hero.trust1')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-primary-400"></i>
            {t('hero.trust2')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-primary-400"></i>
            {t('hero.trust3')}
          </span>
        </div>
      </div>
    </section>
  );
}